export const COLORS = ['default', 'danger', 'accent'] as const

export type Color = (typeof COLORS)[number]
